import CloseIcon from "@mui/icons-material/Close";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useModalDismiss } from "@/helper/customHooks/useModalDismiss";
import styles from "@/components/lms/lmsMarketing.module.css";

interface Props {
  open: boolean;
  onClose: () => void;
}

export default function LmsBookNowModal({
  open,
  onClose,
}: Props) {
  const { t } = useTranslation();
  const dismiss = useModalDismiss(open, onClose);

  return (
    <Dialog
      open={open}
      {...dismiss}
      fullWidth
      maxWidth="sm"
      aria-labelledby="lms-book-now-title"
      PaperProps={{ className: styles.bookNowDialogPaper }}
    >
      <div className={styles.bookNowHero}>
        <IconButton
          onClick={onClose}
          className={styles.bookNowCloseButton}
          aria-label={t("close")}
        >
          <CloseIcon />
        </IconButton>
        <span className={styles.bookNowHeroIcon} aria-hidden>
          <SchoolOutlinedIcon />
        </span>
        <h2 id="lms-book-now-title" className={styles.bookNowTitle}>
          {t("lms_marketing_modal_title")}
        </h2>
      </div>
      <DialogContent className={styles.bookNowContent}>
        <p className={styles.bookNowDescription}>
          {t("lms_marketing_modal_description")}
        </p>
        <div className={styles.bookNowContactGrid}>
          <a
            href="mailto:service@kaerhealth.com"
            className={styles.bookNowContactCard}
          >
            <span className={styles.bookNowContactIcon} aria-hidden>
              <MailOutlineIcon />
            </span>
            <span>
              <strong>{t("email")}</strong>
              <small>service@kaerhealth.com</small>
            </span>
          </a>
          <a
            href="tel:+498941433333"
            className={styles.bookNowContactCard}
          >
            <span className={styles.bookNowContactIcon} aria-hidden>
              <LocalPhoneOutlinedIcon />
            </span>
            <span>
              <strong>{t("phone")}</strong>
              <small>089-41433333</small>
            </span>
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
}
